import { pageHead, unavailableHead, hasUnavailableMatch } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import BeatMyEstimate from "@/pages/BeatMyEstimate";

export const Route = createFileRoute("/_public/beat-my-estimate")({
  head: ({ matches }) => hasUnavailableMatch(matches) ? unavailableHead() : pageHead("Send Us Your Fence Estimate \u2014 We'll Beat It by Thousands | Modern Fence Install", "Send any competitor's fence estimate and we'll beat it by thousands \u2014 engineered specifically for what you need to protect. Same-day response. Free, no obligation.", "/beat-my-estimate", false),
  component: BeatMyEstimate,
});
